// ===== Modalidade de transporte: id -> nome =====
//
// Spec: docs/superpowers/specs/2026-10-08-frete-da-outra-transportadora.md
//
// A tela (src/data.jsx, TRANSPORTE_MODALIDADES) e o documento do cliente (esta funcao roda em Deno) precisam do mesmo
// nome para o mesmo id. Esta tabela e a COPIA da funcao, sem import (um `import` que o Deno nao resolva quebra a pagina do
// cliente em producao, e nao no teste); tests/unit/modalidade-do-frete.test.js compara as duas, id por id e nome por nome.
//
// Os ids sao os da NF-e/Nomus (`modFrete`): 0 = por conta do emitente (CIF), 1 = por conta do destinatario (FOB)...
export const MODALIDADES_TRANSPORTE = {
  0: 'CIF · por conta do emitente',
  1: 'FOB · por conta do destinatário',
  2: 'Por conta de terceiros',
  3: 'Transporte próprio · emitente',
  4: 'Transporte próprio · destinatário',
  9: 'Sem transporte',
};

/** Nome da modalidade, ou '' quando nao ha (proposta antiga) ou o id e desconhecido: nao inventa nome. */
export function nomeDaModalidade(id) {
  if (id == null || id === '') return '';
  return MODALIDADES_TRANSPORTE[Number(id)] ?? '';
}
